/**
 * 图片预加载工具
 * - 不阻塞页面渲染（利用 requestIdleCallback / setTimeout 延迟启动）
 * - 队列请求，一次并行加载 4 张
 */

const CONCURRENCY = 4

function loadImage(url) {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve({ url, success: true })
    img.onerror = () => resolve({ url, success: false })
    img.src = url
  })
}

/**
 * 预加载图片列表
 * @param {string[]} urls - 图片 URL 数组
 * @returns {Promise<Array<{url: string, success: boolean}>>}
 */
export function preloadImages(urls) {
  if (!urls || urls.length === 0) return Promise.resolve([])

  return new Promise((resolve) => {
    const queue = [...urls]
    const results = []
    let active = 0
    let started = false

    function next() {
      while (active < CONCURRENCY && queue.length > 0) {
        const url = queue.shift()
        active++
        loadImage(url).then((result) => {
          results.push(result)
          active--
          if (queue.length > 0) {
            next()
          } else if (active === 0) {
            resolve(results)
          }
        })
      }
    }

    function start() {
      if (started) return
      started = true
      next()
    }

    // 延迟到浏览器空闲时启动，不阻塞页面渲染
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(start)
    } else {
      setTimeout(start, 0)
    }
  })
}
